import { isAxiosError } from "axios";
import { axios } from "../../../utils/axios";
import { toastOptions } from "../../../config/toast";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";

export const getBarrios = async (bar, setBar) => {
  setBar({ ...bar, loading: true });
  let response = await axios().get("barrios");
  if (!isAxiosError(response)) {
    const { data, error } = response.data;
    if (data && !error) {
      setBar({ ...bar, loading: false, data: data });
      toast.success("Barrios cargados", toastOptions);
    }
    if (error && !data) {
      setBar({ ...bar, loading: false, error: error });
      toast.error(error, toastOptions);
    }
  } else {
    setBar({ ...bar, loading: false, error: "Hubo un error inesperado" });
  }
};

export const dataTable = (data) => {
  const columns = [
    { field: "id", headerName: "#", width: 50, flex: 0.5 },
    {
      field: "nombre",
      headerName: "Nombre",
      minWidth: 100,
      flex: 1,
    },
    {
      field: "comision",
      headerName: "Comisión",
      minWidth: 120,
      flex: 1,
    },
    {
      field: "direccion",
      headerName: "Dirección",
      minWidth: 150,
      flex: 1,
    },
    {
      field: "barrio_id",
      headerName: "Acciones",
      renderCell: (p) => {
        return (
          <div>
            <Link className="btn btn-sm btn-primary" to={`/barrio/${p.row.id}`}>
              Ver Información
            </Link>
          </div>
        );
      },
      minWidth: 120,
      flex: 1,
    },
  ];

  const rows = data.map((d) => {
    return {
      id: d.id,
      nombre: d.nombre,
      comision: d.comision,
      direccion: d.direccion,
      barrio_id: d.id,
      poligonos: d.poligonos,
    };
  });

  const filter = (d, value) => {
    value = value.toLowerCase();
    return (
      d.id?.toString().toLowerCase().includes(value) ||
      d.nombre?.toLowerCase().includes(value) ||
      d.direccion?.toLowerCase().includes(value) ||
      d.comision?.toString().toLowerCase().includes(value)
    );
  };

  return { columns, rows, filter };
};
